import { inAppProvider } from './in-app/InAppProvider'
import { docusignProvider } from './docusign/DocuSignProvider'
import { adobeSignProvider } from './adobe-sign/AdobeSignProvider'
import type { SignatureProvider, SignatureProviderId } from './types'

export { inAppProvider, docusignProvider, adobeSignProvider }
export type { SignatureProvider, SignatureProviderId, SignatureRequest, SignatureResult, SigningSurfaceProps } from './types'

export const ALL_SIGNATURE_PROVIDERS: SignatureProvider[] = [
  inAppProvider,
  docusignProvider,
  adobeSignProvider,
]

export function getSignatureProvider(id?: SignatureProviderId): SignatureProvider {
  const requested = id ?? (import.meta.env.VITE_ESIGN_PROVIDER as SignatureProviderId | undefined) ?? 'in-app'
  const provider = ALL_SIGNATURE_PROVIDERS.find(p => p.id === requested)
  if (!provider) throw new Error(`Unknown signature provider: ${requested}`)
  if (!provider.available()) {
    throw new Error(
      `Signature provider not available: ${requested}. Falling back is disabled in production.` +
      ` Set VITE_ESIGN_PROVIDER=in-app for the demo.`
    )
  }
  return provider
}
